import React from 'react';
import { homeContent } from '../content';
import IntroSection from '../components/home/IntroSection';
import ApproachSection from '../components/home/ApproachSection';

const HomePage = () => {
  return (
    <div className="container">
      <h1>O škole</h1>
      
      <IntroSection
        title={homeContent.mainTitle}
        paragraphs={homeContent.introduction}
        imageSrc={homeContent.mainImage}
      />

      {/* Temporarily hidden - Náš přístup ke vzdělávání section
      <ApproachSection
        title={homeContent.approachTitle}
        paragraphs={homeContent.approachText}
      />
      */}
    </div>
  );
};

export default HomePage; 